<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="toggleMinimise()"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id; onTabChange(tab.id - 1)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Part I Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active">
        
      <!-- Entity information table inside tab -->
        <table class="table table-bordered form-inline enityDetails custom-table">
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.key }}</span>
            </td>
}
          </tr>
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.value }}</span>
            </td>
}
          </tr>
        </table>

        <!-- Standard input fields row -->
        @if (!loading) {
<table class="table table-bordered form-inline custom-table">
          <tr>
            <td>Name:
              <div>
                <input class="form-control input-md numText text_field_width" style="width: 100%;" type="text"
                     aria-describedby="basic-addon2" [disabled]="true" [(ngModel)]="rowData.LE_NAME">
              </div>
            </td>
            <td>Employer identification number:
              <div>
                <input class="form-control input-md numText text_field_width" style="width: 100%;" type="text"
                     maxlength="10" aria-describedby="basic-addon2" [disabled]="true" [(ngModel)]="rowData.EIN">
              </div>
            </td>
          </tr>
        </table>
}

        @if (!loading) {
<div class="BlackSmHdrBC">
        {{f4626Header?.DESCRIPTION || f4626Header?.ATTRIB_DESCRIPTION}}
          </div>
}

            <table class="table table-bordered form-inline InnerTblBG custom-table">
          <!-- Part I form data for currentPart = '1' -->
              @for (row of f4626FormData; track $index; let mainIndex = $index) {

            <!-- Header rows (TH) -->
                @if (row.ROW_TYPE === 'TH') {
<tr>
                  @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                      [attr.align]="item.COL_CLASS"
                      [attr.colspan]="item.COLSPAN" 
                      style="font-weight: bold;"
                      [ngClass]="{'color-red': item.ATTRIB_VALUE < 0}">
                    
                <!-- Unallocated Amount display with color coding -->
                    @if (item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt !== 0) {
<p
                   [attr.disabled]="item.IS_EDITABLE_CELL === 'N'" style="color:red;">
                  {{item.ATTRIB_VALUE | number}}
                </p>
}
                    @if (item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt === 0) {
<p
                   [attr.disabled]="item.IS_EDITABLE_CELL === 'N'" style="color:green;">
                  {{item.ATTRIB_VALUE | number}}
                </p>
}
                    
                    <!-- Date picker for dateVarious fields -->
                    @if (item.EDIT_TYPE === 'custom_date_various' && item.DATA_TYPE === 'dateVarious') {
<div>
                      @if (item.ATTRIB_DESCRIPTION !== 'NA') {
<label>&nbsp;{{ item.ATTRIB_DESCRIPTION }}</label>
}
                      <br />
                  <input 
                    type="date" 
                    class="form-control input-sm text_field_width"
                    [ngModel]="getDateFormat(item.ATTRIB_VALUE)"
                    (ngModelChange)="updateDateValue(item, $event); valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, 0)"
                               [disabled]="item.IS_EDITABLE_CELL === 'N'">
                    </div>
}
                    
                    @if (item.DESCRIPTION !== 'Unallocated Amount' && item.EDIT_TYPE !== 'custom_date_various') {
<p
                       [attr.disabled]="item.IS_EDITABLE_CELL === 'N'">
                      @if (item.DATA_TYPE === 'number' || item.DATA_TYPE === 'decimal') {
<span>{{item.ATTRIB_VALUE | number}}</span>
}
                      @if (item.DATA_TYPE !== 'number' && item.DATA_TYPE !== 'decimal') {
<span>{{item.ATTRIB_VALUE}}</span>
}
                    </p>
}
                  </td>
}
                </tr>
}

            <!-- Page Header rows (PH) -->
                @if (row.ROW_TYPE === 'PH') {
<tr>
              <td style="font-weight: bold;" 
                  [attr.disabled]="row.Line_data[0].IS_EDITABLE_CELL === 'N'" 
                  colspan="10">
                    {{row.Line_data[0].ATTRIB_VALUE}}
                  </td>
                </tr>
}

            <!-- Data rows (DT) -->
            @if (row.ROW_TYPE === 'DT') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                  [attr.colspan]="item.COLSPAN">
                
                <!-- Currency fields with negative/positive validation -->
                @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number' && item.IS_ZERO_OR_GREATER === 'N') {
<p>
                  <input [(ngModel)]="item.ATTRIB_VALUE"
                         class="form-control input-md numText number-field" 
                         onlyDigits
                         type="text" 
                         (blur)="updateAmount(itemIndex, item.LINE_NO)"
                         (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
                </p>
}
                @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number' && item.IS_ZERO_OR_GREATER === 'Y') {
<p>
                  <input [(ngModel)]="item.ATTRIB_VALUE"
                         class="form-control input-md numText number-field" 
                         onlyPositiveDigits
                         type="text" 
                         (blur)="updateAmount(itemIndex, item.LINE_NO)"
                         (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
                </p>
}

                <!-- Checkbox fields - back to checkboxes as requested -->
                @if (item.EDIT_TYPE === 'radio' && item.DATA_TYPE === 'string') {
<p>
                  @if (item.ATTRIB_DESCRIPTION === 'NA') {
<input 
                         type="checkbox" 
                         [checked]="item.ATTRIB_VALUE === 'Y'"
                         (change)="toggleCheckbox(item, row, itemIndex, mainIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
                  @if (item.ATTRIB_DESCRIPTION !== 'NA') {
<input 
                         type="checkbox" 
                         [checked]="item.ATTRIB_VALUE === 'Y'"
                         (change)="toggleCheckbox(item, row, itemIndex, mainIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
                  @if (item.ATTRIB_DESCRIPTION !== 'NA' && item.ATTRIB_DESCRIPTION) {
<label>&nbsp;{{ item.ATTRIB_DESCRIPTION }}</label>
}
                </p>
}

                <!-- Label fields -->
                    @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string' && item.ATTRIB_VALUE !== '0') {
<p
                       [attr.disabled]="item.IS_EDITABLE_CELL === 'N'">
                      {{item.ATTRIB_VALUE}}
                    </p>
}
                  </td>
}
                </tr>
}

            <!-- Line Header rows (LH) with nested table -->
                @if (row.ROW_TYPE === 'LH') {
<tr>
              <td colspan="10">
                    <table class="table table-bordered form-inline InnerTblBG custom-table">
                  @for (item of row.Line_data; track $index) {

                    <tr>
                      @if (item.ATTRIB_SHORT_CODE?.indexOf('HEADER') !== -1) {

                        @for (subItem of item.Line_data; track $index) {
<th>
                          <p>{{subItem.ATTRIB_VALUE}}</p>
                          </th>
}
                        
}
                      @if (item.ATTRIB_SHORT_CODE?.indexOf('HEADER') === -1) {

                        @for (subItem of item.Line_data; track $index; let subIndex = $index) {
<td>
                          @if (subItem.EDIT_TYPE === 'label' && subItem.DATA_TYPE === 'string') {
<p
                             [attr.colspan]="subItem.COLSPAN">{{subItem.ATTRIB_VALUE}}</p>
}
                          @if (subItem.EDIT_TYPE === 'currency' && subItem.DATA_TYPE === 'number') {
<p>
                            <input class="form-control input-md numText number-field" 
                                   onlyDigits
                                   type="text" 
                                   [(ngModel)]="subItem.ATTRIB_VALUE"
                                   (blur)="updateAmount(subIndex, subItem.LINE_NO)"
                                   [disabled]="subItem.IS_EDITABLE_CELL === 'N'"
                                   (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)">
                          </p>
}
                          @if (subItem.EDIT_TYPE === 'text' && subItem.DATA_TYPE === 'string') {
<p>
                            <input type="text"
                                   (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)"
                                   [disabled]="subItem.IS_EDITABLE_CELL === 'N'"
                                   [(ngModel)]="subItem.ATTRIB_VALUE">
                          </p>
}
                          @if (subItem.EDIT_TYPE === 'select' && subItem.DATA_TYPE === 'string') {
<p>
                            @if (subItem.ATTRIB_SHORT_CODE?.indexOf('CONVENTION') !== -1) {
<select
                                    [(ngModel)]="subItem.ATTRIB_VALUE"
                                    (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)"
                                    [disabled]="subItem.IS_EDITABLE_CELL === 'N'">
                              @for (convension of convensions; track $index) {
<option>{{convension}}</option>
}
                            </select>
}
                            @if (subItem.ATTRIB_SHORT_CODE?.indexOf('METHOD') !== -1) {
<select
                                    [(ngModel)]="subItem.ATTRIB_VALUE"
                                    (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)"
                                    [disabled]="subItem.IS_EDITABLE_CELL === 'N'">
                              @for (method of methods; track $index) {
<option>{{method}}</option>
}
                            </select>
}
                          </p>
}
                        </td>
}
                      
}
                      </tr>
                  
}
                    </table>
                  </td>
                </tr>
}
              
}
            </table>
          </div>
}

    <!-- Part II Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active">
      
      <!-- Entity information table inside tab -->
      <table class="table table-bordered form-inline enityDetails custom-table">
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>

      @if (!loading) {
<div class="BlackSmHdrBC">
        {{f4626Header?.DESCRIPTION || f4626Header?.ATTRIB_DESCRIPTION}}
      </div>
}
      
      <table class="table table-bordered form-inline InnerTblBG custom-table">
          <!-- Part II form data - identical structure as Part I -->
          @for (row of f4626FormData; track $index; let mainIndex = $index) {

            @if (row.ROW_TYPE === 'TH') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                  [attr.align]="item.COL_CLASS" 
                  [attr.colspan]="item.COLSPAN"
                  style="font-weight: bold;">
                <p>{{item.ATTRIB_VALUE}}</p>
              </td>
}
            </tr>
}
            @if (row.ROW_TYPE === 'DT') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td>
                @if (item.EDIT_TYPE === 'currency') {
<input
                       [(ngModel)]="item.ATTRIB_VALUE"
                       class="form-control number-field" 
                       onlyDigits
                       (blur)="updateAmount(itemIndex, item.LINE_NO)"
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                       [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
                @if (item.EDIT_TYPE === 'label') {
<p>{{item.ATTRIB_VALUE}}</p>
}
              </td>
}
            </tr>
}
          
}
        </table>
    </div>
}

    <!-- Part III Tab -->
    @if (activeTab === 3) {
<div class="tab-pane active">
      
      <!-- Entity information table inside tab -->
      <table class="table table-bordered form-inline enityDetails custom-table">
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>

      @if (!loading) {
<div class="BlackSmHdrBC">
        {{f4626Header?.DESCRIPTION || f4626Header?.ATTRIB_DESCRIPTION}}
      </div>
}
      
      <table class="table table-bordered form-inline InnerTblBG custom-table">
          <!-- Part III form data - identical structure -->
          @for (row of f4626FormData; track $index; let mainIndex = $index) {

            @if (row.ROW_TYPE === 'TH') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                  [attr.align]="item.COL_CLASS" 
                  [attr.colspan]="item.COLSPAN"
                  style="font-weight: bold;">
                <p>{{item.ATTRIB_VALUE}}</p>
              </td>
}
            </tr>
}
            @if (row.ROW_TYPE === 'DT') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td>
                @if (item.EDIT_TYPE === 'currency') {
<input
                       [(ngModel)]="item.ATTRIB_VALUE"
                       class="form-control number-field" 
                       onlyDigits
                       (blur)="updateAmount(itemIndex, item.LINE_NO)"
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                       [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
                @if (item.EDIT_TYPE === 'label') {
<p>{{item.ATTRIB_VALUE}}</p>
}
              </td>
}
            </tr>
}
          
}
        </table>
    </div>
}

    <!-- Part IV - Section 1 Tab -->
    @if (activeTab === 4) {
<div class="tab-pane active">
      
      <!-- Entity information table inside tab -->
      <table class="table table-bordered form-inline enityDetails custom-table">
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>

      @if (!loading) {
<div class="BlackSmHdrBC">
        {{f4626Header?.DESCRIPTION || f4626Header?.ATTRIB_DESCRIPTION}}
      </div>
}
      
      <table class="table table-bordered form-inline InnerTblBG custom-table">
          <!-- Part IV Section 1 form data -->
          @for (row of f4626FormData; track $index; let mainIndex = $index) {

            @if (row.ROW_TYPE === 'TH') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                  [attr.align]="item.COL_CLASS" 
                  [attr.colspan]="item.COLSPAN"
                  style="font-weight: bold;">
                <p>{{item.ATTRIB_VALUE}}</p>
              </td>
}
            </tr>
}
            @if (row.ROW_TYPE === 'DT') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td>
                @if (item.EDIT_TYPE === 'currency') {
<input
                       [(ngModel)]="item.ATTRIB_VALUE"
                       class="form-control number-field" 
                       onlyDigits
                       (blur)="updateAmount(itemIndex, item.LINE_NO)"
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                       [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
                @if (item.EDIT_TYPE === 'label') {
<p>{{item.ATTRIB_VALUE}}</p>
}
              </td>
}
            </tr>
}
            @if (row.ROW_TYPE === 'MD') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td>
                @if (item.EDIT_TYPE === 'currency') {
<input
                       [(ngModel)]="item.ATTRIB_VALUE"
                       class="form-control number-field" 
                       onlyDigits
                       (blur)="updateAmount(itemIndex, item.LINE_NO)"
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                       [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
                @if (item.EDIT_TYPE === 'text' && item.DATA_TYPE === 'string') {
<p>
                  {{item.ATTRIB_DESCRIPTION}}
                  <input type="text"
                         [(ngModel)]="item.ATTRIB_VALUE"
                         class="form-control"
                         (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
                </p>
}
                @if (item.EDIT_TYPE === 'label') {
<p>{{item.ATTRIB_VALUE}}</p>
}
              </td>
}
            </tr>
}
          
}
        </table>
        </div>
}

        <!-- Part IV - Section 3 Tab -->
    @if (activeTab === 5) {
<div class="tab-pane active">
      
      <!-- Entity information table inside tab -->
      <table class="table table-bordered form-inline enityDetails custom-table">
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>

      @if (!loading) {
<div class="BlackSmHdrBC">
        {{f4626Header?.DESCRIPTION || f4626Header?.ATTRIB_DESCRIPTION}}
      </div>
}
      
      <table class="table table-bordered form-inline InnerTblBG custom-table">
        <!-- Part IV Section 3 form data -->
        @for (row of f4626FormData; track $index; let mainIndex = $index) {

          @if (row.ROW_TYPE === 'TH') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                [attr.align]="item.COL_CLASS" 
                [attr.colspan]="item.COLSPAN"
                style="font-weight: bold;">
              <p>{{item.ATTRIB_VALUE}}</p>
            </td>
}
          </tr>
}
          @if (row.ROW_TYPE === 'DT') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td>
              @if (item.EDIT_TYPE === 'currency') {
<input
                     [(ngModel)]="item.ATTRIB_VALUE"
                     class="form-control number-field" 
                     onlyDigits
                     (blur)="updateAmount(itemIndex, item.LINE_NO)"
                     (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                     [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
              @if (item.EDIT_TYPE === 'text' && item.DATA_TYPE === 'string') {
<p>
                {{item.ATTRIB_DESCRIPTION}}
                <input type="text"
                       [(ngModel)]="item.ATTRIB_VALUE"
                       class="form-control"
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                       [disabled]="item.IS_EDITABLE_CELL === 'N'">
              </p>
}
              @if (item.EDIT_TYPE === 'label') {
<p>{{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}
          <!-- Additional MD rows for Section 3 rows 2a-2e -->
          @if (row.ROW_TYPE === 'MD') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td>
              @if (item.EDIT_TYPE === 'currency') {
<input
                     [(ngModel)]="item.ATTRIB_VALUE"
                     class="form-control number-field" 
                     onlyDigits
                     (blur)="updateAmount(itemIndex, item.LINE_NO)"
                     (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                     [disabled]="item.IS_EDITABLE_CELL === 'N'">
}
              @if (item.EDIT_TYPE === 'text' && item.DATA_TYPE === 'string') {
<p>
                {{item.ATTRIB_DESCRIPTION}}
                <input type="text"
                       [(ngModel)]="item.ATTRIB_VALUE"
                       class="form-control"
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                       [disabled]="item.IS_EDITABLE_CELL === 'N'">
              </p>
}
              @if (item.EDIT_TYPE === 'label') {
<p>{{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}
        
}
      </table>
    </div>
}

    <!-- Part VI - Section 2 Tab -->
    @if (activeTab === 6) {
<div class="tab-pane active">
      
      <!-- Entity information table inside tab -->
      <table class="table table-bordered form-inline enityDetails custom-table">
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>

      @if (!loading) {
<div class="BlackSmHdrBC">
        {{f4626Header?.DESCRIPTION || f4626Header?.ATTRIB_DESCRIPTION}}
      </div>
}
      
      <table class="table table-bordered form-inline InnerTblBG custom-table">
          <!-- Part VI Section 2 form data -->
          @for (row of f4626FormData; track $index; let mainIndex = $index) {

            @if (row.ROW_TYPE === 'TH') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                  [attr.align]="item.COL_CLASS" 
                  [attr.colspan]="item.COLSPAN"
                  style="font-weight: bold;">
                <p>{{item.ATTRIB_VALUE}}</p>
              </td>
}
            </tr>
}
            
            @if (row.ROW_TYPE === 'DT') {
<tr>
              @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
                
                <!-- Currency fields with negative/positive validation -->
                @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number' && item.IS_ZERO_OR_GREATER === 'N') {
<p>
                  <input [(ngModel)]="item.ATTRIB_VALUE"
                         class="form-control input-md numText number-field" 
                         onlyDigits
                         type="text" 
                         (blur)="updateAmount(itemIndex, item.LINE_NO)"
                         (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
                </p>
}
                @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number' && item.IS_ZERO_OR_GREATER === 'Y') {
<p>
                  <input [(ngModel)]="item.ATTRIB_VALUE"
                         class="form-control input-md numText number-field" 
                         onlyPositiveDigits
                         type="text" 
                         (blur)="updateAmount(itemIndex, item.LINE_NO)"
                         (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"
                         [disabled]="item.IS_EDITABLE_CELL === 'N'">
                </p>
}

                <!-- Radio/Checkbox fields -->
                @if (item.EDIT_TYPE === 'radio' && item.DATA_TYPE === 'string') {
<p>
                  @if (item.ATTRIB_DESCRIPTION === 'NA') {
<input 
                         [(ngModel)]="item.ATTRIB_VALUE"
                         type="checkbox" 
                         [value]="item.ATTRIB_VALUE === 'Y'"
                         (change)="toggleCheckbox(item, row, itemIndex, mainIndex)">
}
                  
                  @if (item.ATTRIB_DESCRIPTION !== 'NA') {
<input 
                         [(ngModel)]="item.ATTRIB_VALUE"
                         type="checkbox" 
                         [value]="item.ATTRIB_VALUE === 'Y'"
                         (change)="toggleCheckbox(item, row, itemIndex, mainIndex)">
}
                  
                  @if (item.ATTRIB_DESCRIPTION !== 'NA') {
<label>&nbsp;{{item.ATTRIB_DESCRIPTION}}</label>
}
                </p>
}

                <!-- Label fields -->
                @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string' && item.ATTRIB_VALUE !== '0') {
<p>
                  {{item.ATTRIB_VALUE}}
                </p>
}
              </td>
}
            </tr>
}
            
            <!-- Line Header rows (LH) with nested table for Part VI -->
            @if (row.ROW_TYPE === 'LH') {
<tr>
              <td colspan="10">
                <table class="table table-bordered form-inline InnerTblBG custom-table">
                  @for (item of row.Line_data; track $index) {

                    <tr>
                      @if (item.ATTRIB_SHORT_CODE?.indexOf('HEADER') !== -1) {

                        @for (subItem of item.Line_data; track $index) {
<th>
                          <p>{{subItem.ATTRIB_VALUE}}</p>
                        </th>
}
                      
}
                      
                      @if (item.ATTRIB_SHORT_CODE?.indexOf('HEADER') === -1) {

                        @for (subItem of item.Line_data; track $index; let subIndex = $index) {
<td>
                          
                          <!-- Label fields -->
                          @if (subItem.EDIT_TYPE === 'label' && subItem.DATA_TYPE === 'string') {
<p
                             [attr.colspan]="subItem.COLSPAN">{{subItem.ATTRIB_VALUE}}</p>
}
                          
                          <!-- Currency fields -->
                          @if (subItem.EDIT_TYPE === 'currency' && subItem.DATA_TYPE === 'number') {
<p>
                            <input class="form-control input-md numText number-field" 
                                   onlyDigits
                                   type="text" 
                                   [(ngModel)]="subItem.ATTRIB_VALUE"
                                   (blur)="updateAmount(subIndex, subItem.LINE_NO)"
                                   [disabled]="subItem.IS_EDITABLE_CELL === 'N'"
                                   (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)">
                          </p>
}
                          
                          <!-- Text fields -->
                          @if (subItem.EDIT_TYPE === 'text' && subItem.DATA_TYPE === 'string') {
<p>
                            <input type="text"
                                   [(ngModel)]="subItem.ATTRIB_VALUE"
                                   class="form-control"
                                   (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)"
                                   [disabled]="subItem.IS_EDITABLE_CELL === 'N'">
                          </p>
}

                          <!-- Select dropdowns for Convention and Method -->
                          @if (subItem.EDIT_TYPE === 'select' && subItem.DATA_TYPE === 'string') {
<p>
                            <!-- Convention dropdown -->
                            @if (subItem.ATTRIB_SHORT_CODE?.indexOf('CONVENTION') !== -1) {
<select
                                    [(ngModel)]="subItem.ATTRIB_VALUE"
                                    class="form-control"
                                    (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)"
                                    [disabled]="subItem.IS_EDITABLE_CELL === 'N'">
                              @for (convention of convensions; track $index) {
<option [value]="convention">
                                {{convention}}
                              </option>
}
                            </select>
}
                            
                            <!-- Method dropdown -->
                            @if (subItem.ATTRIB_SHORT_CODE?.indexOf('METHOD') !== -1) {
<select
                                    [(ngModel)]="subItem.ATTRIB_VALUE"
                                    class="form-control"
                                    (ngModelChange)="valuechanged(mainIndex, null, subItem.LINE_NO, subIndex)"
                                    [disabled]="subItem.IS_EDITABLE_CELL === 'N'">
                              @for (method of methods; track $index) {
<option [value]="method">
                                {{method}}
                              </option>
}
                            </select>
}
                          </p>
}
                        </td>
}
                      
}
                    </tr>
                  
}
                </table>
              </td>
            </tr>
}
          
}
        </table>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName !== 'Subsidiary') {
<button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
    </button>
}
  @if (currentTabName !== 'Subsidiary') {
<button class="reset-button" type="button" (click)="reset()">Reset</button>
}
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>